if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
        constructor() {
            super();
            this.isUpdating = false;
        }

        connectedCallback() {
            this.initCart();
            PubSub.subscribe('cart-updated', this.openCart.bind(this));
            PubSub.subscribe('cart-updated', this.updateCart.bind(this));
        }

        disconnectedCallback() {
            this.itemsResizeObserver?.disconnect();
        }

        initItemsCue() {
            this.itemsResizeObserver?.disconnect();
            const items = this.querySelector('.cart_line-items');
            const cue = this.querySelector('.cart-more-items');
            if (!items || !cue) return;

            const updateCue = () => {
                const lastItem = items.querySelector('.cart_line_item:last-child');
                cue.hidden = !lastItem || lastItem.getBoundingClientRect().bottom <= items.getBoundingClientRect().bottom + 2;
            };
            if (!items.dataset.cueListenerAdded) {
                items.addEventListener('scroll', updateCue, { passive: true });
                cue.addEventListener('click', () => {
                    items.focus({ preventScroll: true });
                    items.scrollBy({
                        top: items.clientHeight * 0.8,
                        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
                    });
                });
                items.dataset.cueListenerAdded = 'true';
            }
            this.itemsResizeObserver = new ResizeObserver(updateCue);
            this.itemsResizeObserver.observe(items);
            items.querySelectorAll('.cart_line_item').forEach((item) => this.itemsResizeObserver.observe(item));
            updateCue();
        }

        initCart() {
            this.initItemsCue();
            this.productRemove = this.querySelectorAll('.cart_line_item-remove');
            this.productQty = this.querySelectorAll('.cart_line_item-qty__update');

            const closeBtn = this.querySelector('.cart-drawer-close');
            const closeDrawerBtn = this.querySelector('.close_cart_drawer');

            if (closeBtn && !closeBtn.dataset.listenerAdded) {
                closeBtn.addEventListener('click', this.closeCart.bind(this));
                closeBtn.dataset.listenerAdded = 'true';
            }

            if (closeDrawerBtn && !closeDrawerBtn.dataset.listenerAdded) {
                closeDrawerBtn.addEventListener('click', this.closeCart.bind(this));
                closeDrawerBtn.dataset.listenerAdded = 'true';
            }

            this.productRemove.forEach((el) => {
                if (el.dataset.listenerAdded) return;

                el.addEventListener('click', (e) => {
                    this.removeProduct(e.currentTarget.dataset.line);
                });

                el.dataset.listenerAdded = 'true';
            });

            this.productQty.forEach((el) => {
                if (el.dataset.listenerAdded) return;

                el.addEventListener('click', (e) => {
                    this.changeCount(
                        e.currentTarget.dataset.line,
                        e.currentTarget.dataset.quantity
                    );
                });

                el.dataset.listenerAdded = 'true';
            });
        }

        openCart() {
            this.classList.add('active');
        }

        closeCart() {
            this.classList.remove('active');
        }

        updateCart() {
            if (this.isUpdating) return;

            this.isUpdating = true;

            fetch(window.theme.shopUrl + `?section_id=${this.dataset.sectionid}`)
                .then((res) => res.text())
                .then((data) => {
                    const html = new DOMParser().parseFromString(data, 'text/html');

                    const currentContainer = this.querySelector('.cart_container');
                    const newContainer = html.querySelector('.cart_container');
            

                    if (!currentContainer || !newContainer) return;
                    console.log(currentContainer)
                    currentContainer.querySelectorAll('lb-upsell-widget').forEach((el) => el.remove());
                    console.log(currentContainer)
                    currentContainer.innerHTML = newContainer.innerHTML;

                    const count = html.querySelector('.cart_totals-title')?.dataset.item_count;
                    const cartQuantity = document.querySelector('.cart-quantity');

                    if (count !== undefined && cartQuantity) {
                        cartQuantity.innerHTML = count;
                    }

                    this.initCart();
                })
                .catch((error) => {
                    console.error('Error', error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.isUpdating = false;
                    }, 300);
                });
        }

        removeProduct(id) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    line: id,
                    quantity: 0,
                }),
            };

            fetch(window.theme.shopUrl + '/cart/change.js', requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        changeCount(id, quantity) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    line: id,
                    quantity: quantity,
                }),
            };

            fetch(window.theme.shopUrl + '/cart/change.js', requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }

                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    });
}

if (!window.__cartSyncPatched) {
    window.__cartSyncPatched = true;

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        try {
            const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

            if (
                response.ok &&
                url &&
                (
                    url.includes('/cart/add.js') ||
                    url.includes('/cart/change.js') ||
                    url.includes('/cart/update.js')
                )
            ) {
                PubSub.publish(PubSub.EVENTS.cartUpdated);
            }
        } catch (error) {
            console.error('Cart sync error:', error);
        }

        return response;
    };
}

// Keep storefront navigation inside a shared preview instead of returning to the live theme.
if (window.location.hostname.endsWith('.shopifypreview.com')) {
    document.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[href]');
        if (!link) return;

        const url = new URL(link.href);
        const storeHosts = ['addallxr.com', 'www.addallxr.com', window.Shopify.shop, window.location.hostname];
        if (!storeHosts.includes(url.hostname) || !['http:', 'https:'].includes(url.protocol)) return;
        if (url.pathname.startsWith('/checkout')) return;

        url.host = window.location.host;
        url.protocol = window.location.protocol;
        url.searchParams.delete('preview_theme_id');
        link.href = url.href;
    }, true);
}
